import classNames from 'classnames';
import { ApplicationState } from '../../../utils/enums';
import { ActionIcon, FavouriteIcon } from '@tymbe/ui-icons';
import { ApplicationData } from '../../../types/TymbeApi';
import { JSX } from 'react';
import moment from 'moment';
import Tooltip from 'rc-tooltip';

interface TymberAppStateIconProps {
  application: ApplicationData;
}

const enum TymberApplicationStateKeys {
  confirmed,
  rejected,
  invited,
  inviteExpired,
  canceled,
  canceledEarly,
  canceledLate,
  systemCanceled,
  employerCanceled,
}

const TymberAppStateIcon = ({ application }: TymberAppStateIconProps) => {
  let tymberApplicationState: TymberApplicationStateKeys;

  switch (application.state) {
    case ApplicationState.CONFIRMED:
      tymberApplicationState = TymberApplicationStateKeys.confirmed;
      break;
    case ApplicationState.REJECTED:
      tymberApplicationState = TymberApplicationStateKeys.rejected;
      break;
    case ApplicationState.SYSTEM_CANCELED:
      tymberApplicationState = TymberApplicationStateKeys.systemCanceled;
      break;
    case ApplicationState.EMPLOYER_CANCELED:
      tymberApplicationState = TymberApplicationStateKeys.employerCanceled;
      break;
    case ApplicationState.CANCELED_EARLY:
      tymberApplicationState = TymberApplicationStateKeys.canceledEarly;
      break;
    case ApplicationState.CANCELED_LATE:
      tymberApplicationState = TymberApplicationStateKeys.canceledLate;
      break;
    case ApplicationState.CANCELED:
      tymberApplicationState = TymberApplicationStateKeys.canceled;
      break;
    case null:
      if (moment(application.deleted_at).isAfter(moment())) {
        tymberApplicationState = TymberApplicationStateKeys.invited;
      } else {
        tymberApplicationState = TymberApplicationStateKeys.inviteExpired;
      }
  }
  return (
    <Tooltip
      placement="top"
      trigger={['hover']}
      overlay={TymberApplicationStates[tymberApplicationState!].tooltip}
    >
      <div
        className={classNames(
          'flex justify-center items-center size-2.5 border-[1.5px] border-bg rounded-full absolute -right-1 -bottom-1 box-content',
          TymberApplicationStates[tymberApplicationState!].bg
        )}
      >
        {TymberApplicationStates[tymberApplicationState!].icon}
      </div>
    </Tooltip>
  );
};

export default TymberAppStateIcon;

type TymberApplicationStateValues = {
  [key in TymberApplicationStateKeys]: {
    bg: string;
    icon: JSX.Element;
    tooltip: string;
  };
};

const TymberApplicationStates: TymberApplicationStateValues = {
  [TymberApplicationStateKeys.confirmed]: {
    bg: 'bg-green-700',
    icon: <FavouriteIcon name="check" className="size-2" />,
    tooltip: 'Potvrzeno',
  },
  [TymberApplicationStateKeys.rejected]: {
    bg: 'bg-red-700',
    icon: <FavouriteIcon name="close" className="size-2" />,
    tooltip: 'Odmítnuto',
  },
  [TymberApplicationStateKeys.invited]: {
    bg: 'bg-secondary-600',
    icon: <ActionIcon name="question_mark" className="size-2" />,
    tooltip: 'Pozván',
  },
  [TymberApplicationStateKeys.inviteExpired]: {
    bg: 'bg-orange-500',
    icon: <FavouriteIcon name="close" className="size-2" />,
    tooltip: 'Pozvání vypršelo',
  },
  [TymberApplicationStateKeys.canceled]: {
    bg: 'bg-red-700',
    icon: <FavouriteIcon name="close" className="size-2" />,
    tooltip: 'Zrušeno',
  },
  [TymberApplicationStateKeys.canceledEarly]: {
    bg: 'bg-red-700',
    icon: <FavouriteIcon name="close" className="size-2" />,
    tooltip: 'Odhlášeno Tymberem',
  },
  [TymberApplicationStateKeys.canceledLate]: {
    bg: 'bg-red-700',
    icon: <FavouriteIcon name="close" className="size-2" />,
    tooltip: 'Nahlášená absence',
  },
  [TymberApplicationStateKeys.systemCanceled]: {
    bg: 'bg-red-700',
    icon: <FavouriteIcon name="close" className="size-2" />,
    tooltip: 'Zrušeno systémem',
  },
  [TymberApplicationStateKeys.employerCanceled]: {
    bg: 'bg-red-700',
    icon: <FavouriteIcon name="close" className="size-2" />,
    tooltip: 'Zrušeno zaměstnavatelem',
  },
};

